module.exports = __webpack_public_path__ + "static/media/FOOTL.149b84d2.svg";